import { useLocation, useRoutes } from 'react-router-dom';
import RoutingHandler from 'src/router';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import {
  hideNavItems,
  showNavItems
} from './redux-store/slices/navigationSlice';
import { Toaster } from 'react-hot-toast';
import CustomErrorPopup from './ui-component/CustomErrorPopup';
import { RootState } from './redux-store/appStore';

function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const token = useSelector((store: RootState) => Object?.keys(store.user.userDetails)?.length);
  const router = RoutingHandler(token)
  const content = useRoutes(router);
  const error = useSelector((state: any) => state?.error?.errorMessage);

  useEffect(() => {
    const restrictedPaths = [
      '/dashboard',
      '/subscriptions',
      '/configuration',
      '/users',
      '/township-configuration',
      '/account-settings',
      '/user-profile'
    ];
    const shouldHideNav = restrictedPaths.some((path) =>
      location.pathname.startsWith(path)
    );

    dispatch(shouldHideNav ? hideNavItems() : showNavItems());
  }, [location, dispatch]);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        <Toaster />
        {content}
        {error && <CustomErrorPopup message={error} />}
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
